import { gql } from 'apollo-angular';

export default gql`
  query elementTypes($tenantUri: String!, $spaceUri: String) {
    elementTypes(tenantUri: $tenantUri, spaceUri: $spaceUri) {
      __typename
      uri
      name
      tenantUri
      description
      icon
      color
      elementControlUris #FIXME does this need a child scope?
      version
      mandatory
      default
      createdOn
      createdByUri
      updatedOn
      updatedByUri
      origin
      originType
      originUri
    }
  }
`;
